import React, {useContext} from 'react';
import Employee from "./Templates/Employee";
import {PhonePanelContext} from "../../contexts/contexts";
import {useMedia} from "../../hooks/useMedia";
import {mediaToM} from "../../helpers/media-queries";

const SidebarEmployee = ({isActive, employee}) => {
  const {setActive} = useContext(PhonePanelContext)
  const toTablet = useMedia(mediaToM)

  const activePhonePanel = () => {
    if (toTablet) {
      setActive(true)
    }
  }

  return (
    <div
      onClick={activePhonePanel}
      className={`hover-change blue normal-radius cursor-pointer s-px-6px s-py-4px hover-change ${isActive && 'is-active'}`}>
      <Employee employee={employee}/>
    </div>
  );
};

export default SidebarEmployee;
